import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/home';
import Prospecting from './components/prospecting/Prospecting';
import BusinessLanding from './components/landing/BusinessLanding';
import Checkout from './components/payments/Checkout';
import ArchivedOffer from './components/payments/ArchivedOffer';

function App() {
  if(document.getElementById('maincode-offer-config'))return <ArchivedOffer/>;
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/prospeccao" element={<Prospecting />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/pagamento" element={<Checkout />} />
        <Route path="/oferta" element={<ArchivedOffer />} />
        <Route path="/modelos/:segment" element={<BusinessLanding />} />
        <Route path="/p/:token" element={<BusinessLanding />} />
        <Route path="/ivanildoeletricista/index.html" element={<Navigate to="/ivanildoeletricista" replace />} />
        <Route path="/dashboard/prospeccao" element={<Navigate to="/prospeccao" replace />} />
        <Route path="/:slug" element={<BusinessLanding />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
